export const CategorySelectionTimeout = parseInt(process.env.VUE_APP_TIMEOUT);
